import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ApplicationState } from '../../store/application-store';
import * as withSoftLabelsActions from '../../soft-labels/actions/soft-labels';


/**
 * Performs supposedly "global" initialisation.
 * @todo: consider modifying the consumers to access the state via services instead of direct store access
 * and then ensuring the services issue the load actions if the store state is not present
 */
@Injectable()
export class GlobalStartupService {
  constructor(private store: Store<ApplicationState>) {
  }

  initSystemSettings() {
    this.initSoftLabels();
  }

  private initSoftLabels() {
    this.store
      .pipe(select((state) => state.softLabels.loaded))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new withSoftLabelsActions.Load());
        }
      }).unsubscribe();
  }
}
